module.exports = __webpack_public_path__ + "static/media/personDashboard.55eb4ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personDashboard.png
// module id = 760
// module chunks = 1 3